import { Col, Divider, Row } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import lodash from 'lodash'
import { formatMoneyByUnit } from '../../../core/helpers/string'
import Item from './Item'
import Skeleton from 'react-loading-skeleton'
import { useTheme } from '../../../hooks/useTheme'
interface FeeBoxProps {
	orderDetail: any
	loading: boolean
}
const FeeBox = (props: FeeBoxProps) => {
	const { t } = useTranslation()
	const [theme] = useTheme()
	const [totalAmount, setTotalAmount] = useState<any>()
	const [exchangedTotalAmount, setExchangedTotalAmount] = useState<any>()
	const [merchantShippingCost, setMerchantShippingCost] = useState<any>()
	const [exchangedMerchantShippingCost, setExchangedMerchantShippingCost] = useState<any>()
	const [totalFee, setTotalFee] = useState<any>()
	const [grandTotal, setGrandTotal] = useState<any>()
	const [totalRefund, setTotalRefund] = useState<any>()
	const [totalPaid, setTotalPaid] = useState<any>()
	const [totalUnpaid, setTotalUnpaid] = useState<any>()
	const [currencyMarketplace, setCurrencyMarketplace] = useState<any>()
	const [currencyProvider, setCurrencyProvider] = useState<any>()
	const { orderDetail, loading } = props
	const [feeSubLabel, setFeeSubLabel] = useState('')

	useEffect(() => {
		if (orderDetail) {
			setTotalAmount(lodash.get(orderDetail, 'totalAmount', ''))
			setExchangedTotalAmount(lodash.get(orderDetail, 'exchangedTotalAmount', ''))
			setMerchantShippingCost(lodash.get(orderDetail, 'merchantShippingCost', ''))
			setExchangedMerchantShippingCost(lodash.get(orderDetail, 'exchangedMerchantShippingCost', ''))
			setTotalPaid(lodash.get(orderDetail, 'totalPaid', ''))
			setTotalUnpaid(lodash.get(orderDetail, 'totalUnpaid', ''))
			setTotalRefund(lodash.get(orderDetail, 'totalRefund', ''))
			setGrandTotal(lodash.get(orderDetail, 'grandTotal', ''))
			setCurrencyMarketplace(lodash.get(orderDetail, 'currency', ''))
			let provider = lodash.get(orderDetail, 'provider.currency', '')
			if (provider) {
				setCurrencyProvider(JSON.parse(provider).code)
			}
			let totalFee = 0
			let feeSubLabel = '(3) = '

			// eslint-disable-next-line array-callback-return
			orderDetail.fees.map((x: any, idx: any) => {
				if (!x.free) {
					if (x.manual && x.actualAmount) {
						totalFee = totalFee + x.actualAmount
					} else if (!x.manual && x.provisionalAmount) {
						totalFee = totalFee + x.provisionalAmount
					}
				}
				feeSubLabel += `(3.${idx + 1}) ${idx !== orderDetail.fees.length - 1 ? '+' : ''} `
			})
			setFeeSubLabel(feeSubLabel)

			setTotalFee(totalFee)
			let total =
				totalFee +
				lodash.get(orderDetail, 'exchangedTotalAmount', 0) +
				lodash.get(orderDetail, 'exchangedMerchantShippingCost', 0)
			setGrandTotal(total)
			setTotalUnpaid(total - lodash.get(orderDetail, 'totalPaid', 0) + lodash.get(orderDetail, 'totalRefund', 0))
		}
	}, [orderDetail])

	const renderItemFee = (item: any, index: number) => {

		return (
			<Row key={index} className={'dpl-flex justify-content-between align-items-center mg-bt-14'}>
				{!loading ? (
					<Col className={'align-items-center dpl-flex'}>
						<span className={`txt-secondary`}>
							{lodash.get(item, 'type.name', '---')}
						</span>
						<span className='fsz-14 txt-disable mgl5'> (3.{index + 1})</span>
					</Col>
				) : (
					<Skeleton width={55} height={18} />
				)}
				{!loading ? (
					<Col>
						{item.manual || item.free ? (
							<Row className={'justify-content-end'}>
								{item.provisionalAmount && (
									<span
										className={` m22-typo-label_gray txt-linethrough mgr5 ${theme}`}
									>
										{formatMoneyByUnit(item.provisionalAmount, currencyProvider)}
									</span>
								)}
								<span className={` m22-typo-label_gray ${theme}`}>
									{item.free
										? t('orderDetail.feeFree')
										: formatMoneyByUnit(item.actualAmount, currencyProvider)}
								</span>
							</Row>
						) : (
							<Row className={'justify-content-end'}>
								<span className={' '}>
									{formatMoneyByUnit(item.provisionalAmount, currencyProvider)}
								</span>
							</Row>
						)}
					</Col>
				) : (
					<Skeleton width={50} height={18} />
				)}
			</Row>
		)
	}
	const renderFee = () => {
		return (
			<div className={`${loading ? 'mg-bt-6' : ''} mg-l-16`}>
				{orderDetail && orderDetail.fees.map((x: any, index: number) => renderItemFee(x, index))}
			</div>
		)
	}
	
	return (
		<div>
			<div className={`dpl-flex flex-col fee-box-top bg-color-pink pd-16 ${theme}`}>
				<Item
					number={'(1)'}
					label={t('orderDetail.totalAmount')}
					subValue={totalAmount}
					value={exchangedTotalAmount}
					currencyValue={currencyProvider}
					currencySubValue={currencyMarketplace}
					loading={loading}
				/>
				<Item
					number={'(2)'}
					label={t('orderDetail.merchantShippingCost')}
					subValue={merchantShippingCost}
					value={exchangedMerchantShippingCost}
					currencyValue={currencyProvider}
					currencySubValue={currencyMarketplace}
					loading={loading}
				/>
				<Item
					number={feeSubLabel}
					label={t('orderDetail.totalFee')}
					value={totalFee}
					currencyValue={currencyProvider}
					loading={loading}
				/>
				<Divider className={`my-0 mg-bt-14`} dashed />
				{renderFee()}
				<Divider className={`my-0 mg-bt-14`} dashed />
				<Item
					number={`(4) = (1) + (2) + (3)`}
					valueClass={'robotomedium'}
					label={t('orderDetail.grandTotal')}
					value={grandTotal}
					currencyValue={currencyProvider}
					loading={loading}
					className={'mg-bt-0'}
				/>
			</div>
			<div className={`dpl-flex pd-16 pdr10 flex-col fsz-14 bg-color-pink fee-box-bottom mgt8 ${theme}`}>
				<Item
					number={'(5)'}
					label={t('orderDetail.totalPaid')}
					value={totalPaid}
					currencyValue={currencyProvider}
					loading={loading}
					valueClass='txt-color-blue5'
				/>
				<Item
					number={'(6)'}
					label={t('orderDetail.totalRefund')}
					value={totalRefund}
					currencyValue={currencyProvider}
					loading={loading}
				/>
				{orderDetail && orderDetail.status !== 'CANCELLED' ? (
					<Item
						number={'(7) = (4) - (5) + (6)'}
						valueClass={'robotomedium txt-error m22-typo-red'}
						label={t(`orderDetail.${totalUnpaid >= 0 ? 'totalUnpaid' : 'totalCash'}`)}
						value={totalUnpaid ? Math.abs(totalUnpaid) : totalUnpaid}
						currencyValue={currencyProvider}
						loading={loading}
						className={'mg-bt-0'}
					/>
				) : null}
				{orderDetail?.totalClaim && (
					<Item
						label={t('orderDetail.totalClaim')}
						value={lodash.get(orderDetail, 'totalClaim', 0)}
						currencyValue={currencyProvider}
						loading={loading}
					/>
				)}
				{orderDetail?.totalCollect && (
					<Item
						label={t('orderDetail.totalCollect')}
						value={Math.abs(lodash.get(orderDetail, 'totalCollect', 0))}
						currencyValue={currencyProvider}
						loading={loading}
					/>
				)}
			</div>
		</div>
	)
}

export default FeeBox

